import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { UerExportWorkOrderChangeAnalyticsQuery } from 'gql/graphql';
import { downloadURI } from 'utils/downloadDataURI';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerExportWorkOrderChangeAnalyticsAsExcelGql } from '../exportWorkOrderChangeAnalyticsQueries';

const requestId = 'uerExportWorkOrderChangeAnalyticsAsExcel';

export const useUerExportWorkOrderChangeAnalyticsAsExcel = (workOrderChangeId: number, onSuccess: () => void) => {
    const dispatch = useDispatch();

    const [resetData] = useResetStoreData({ requestId });

    const downloadHandler = useCallback(
        (result: TActionCommonInterface<UerExportWorkOrderChangeAnalyticsQuery>) => {
            const { dataUrl, name } = result?.payload?.uerExportWorkOrderChangeAnalytics?.data ?? {};

            if (dataUrl && name) {
                downloadURI(dataUrl, name);
            }
            resetData(undefined);
            onSuccess();
        },
        [onSuccess, resetData],
    );

    const [, status, , request] = useRequest({
        requestId,
        query: uerExportWorkOrderChangeAnalyticsAsExcelGql,
        withEffect: false,
        dependenciesUpdater: downloadHandler,
    });

    const makeRequest = useCallback(
        (workOrderVersionId: number) => {
            resetData(undefined);

            dispatch(request({ workOrderChangeId, workOrderVersionId }));
        },
        [dispatch, request, resetData, workOrderChangeId],
    );

    useEffect(() => {
        resetData(undefined);
    }, [resetData]);

    return {
        uerExportRequest: makeRequest,
        uerExportStatus: status,
    };
};
